<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><path d="M14.574,129.9H5.426A4.934,4.934,0,0,0,.5,134.826v9.148A4.934,4.934,0,0,0,5.426,148.9h9.148a4.934,4.934,0,0,0,4.926-4.926v-9.148A4.934,4.934,0,0,0,14.574,129.9Zm3.418,14.175a3.39,3.39,0,0,1-3.418,3.418H5.426a3.406,3.406,0,0,1-2.614-1.206H4.32a3.116,3.116,0,0,0,0-6.233H1.907v-5.228a3.39,3.39,0,0,1,3.418-3.418h9.148a3.39,3.39,0,0,1,3.418,3.418v9.249Z" transform="translate(-0.5 -129.9)" fill="#293ad3"/></svg>
</template>
<script>
  export default {
    name: 'IconLeftBottom3',
  };
</script>
